module.exports = __webpack_public_path__ + "static/media/fingerprint.1293f12b.svg";